<ion-content>
  <ion-grid
    class="modal-container"
    [ngClass]="{
      'parking-time-reservation-pick__outher-container': !notificationConfirmation
    }"
  >
    <ion-row class="content-padding-vertical h-100" justify-content-center>
      <ion-col class="display-flex flex-direction-column">
        <app-modal-header
          *ngIf="timeToReservation"
          header="{{ 'SPACE.PARKING.TIME_START' | translate }}"
          (close)="onClose()"
          [hideBackButton]="notificationConfirmation"
        >
        </app-modal-header>
        <app-modal-header
          *ngIf="forHowLongReservation"
          header="{{ 'SPACE.PARKING.HOW_LONG' | translate }}"
          (close)="onClose()"
          [hideBackButton]="notificationConfirmation"
        >
        </app-modal-header>
        <ion-grid
          class="display-flex flex-direction-column ion-justify-content-end overflow-hidden"
        >
        <ion-row
            *ngIf="timeToReservation" 
            #buttonsContainer
          >
            <ion-col size="4" *ngFor="let i of startTime">
              <ion-button
                (click)="onSetTime($event, i.value);"
                class="parking-time-reservation-pick__hour-button"
                fill="clear"
                shape="round"
              >
                <div>{{ i.name }}</div>
              </ion-button>
            </ion-col>
          </ion-row>
          <ion-row
            *ngIf="forHowLongReservation" 
            #buttonsContainer
          >
            <ion-col *ngFor="let i of endTime" size="4" [ngClass]="{'hide' : (i.type != 'minute')}" >
              <ion-button
                (click)="onSetTime($event, i.value)"
                class="parking-time-reservation-pick__hour-button"
                fill="clear"
                shape="round"
              >
                <div>{{ i.name }}</div>
              </ion-button>
            </ion-col>

            <ion-col size="8" *ngIf="endOfDay">
              <ion-button
                (click)="onSetTime($event, 'byDayEnd')"
                class="parking-time-reservation-pick__hour-button"
                fill="clear"
                shape="round"
              >
                {{ "BY_DAYS_END" | translate }}
              </ion-button>
            </ion-col>

            <ion-col size="12" *ngIf="timePicker && forHowLongReservation">
              <div
                class="parking-add-reservation__date-input parking-add-reservation__date-input--first"
              >
                <ion-label>
                  {{ "SPACE.PARKING.CHOOSE_TIME" | translate }}
                </ion-label>

                <app-date-time-picker
                  pickerType="timer"
                  [min]="startDate"
                  [max]="maxDate"
                  (afterPickerClosed)="dateTimeChange($event)"
                  [value]="endDate"
                ></app-date-time-picker>
              </div>
              <ion-label class="infoMessage font-size__16" color="danger" *ngIf="infoMessage">
                {{ "SPACE.PARKING.LIMIT_TIME" | translate }}
              </ion-label>
            </ion-col>
          </ion-row>

          <!-- PRZYCISKI POTWIERDZENIA Z NOTYFIKACJI -->
          <ion-row class="ion-margin-top" *ngIf="notificationConfirmation">
            <ion-col size="4">
              <ion-button class="w-100" fill="outline">
                {{ "NO" | translate }}
              </ion-button>
            </ion-col>
            <ion-col size="8">
              <ion-button
                class="w-100"
              >
                {{ "SPACE.FREE_UP" | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col
              size="12"
              class="ion-margin-top"
              *ngIf="!notificationConfirmation"
            >
              <ion-button *ngIf="timeToReservation" (click)="setTimeTo()" class="w-100">
                {{ "SPACE.PARKING.CONFIRM" | translate }}
              </ion-button>
              <ion-button *ngIf="forHowLongReservation" (click)="setTimeFor()" class="w-100">
                {{ "SPACE.PARKING.CONFIRM" | translate }}
              </ion-button>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="errorMessage">
            <ion-col size="12">
              <ion-label color="danger">{{ errorMessage }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ng-template #DialHint>
  <p class="timepicker__dial-hint">{{ "TIMEPICKER_HINT" | translate }}</p>
</ng-template>
<ng-template #cancelBtn>
  <button class="timepicker-button">{{ "CANCEL" | translate }}</button>
</ng-template>
